import { ReactComponent as SvgUniswap } from './Uniswap.svg.es.js';

const SvgExchangeIcons = {
    'Exchange/Uniswap': SvgUniswap
};

export { SvgExchangeIcons };
//# sourceMappingURL=index.es.js.map
